import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import logo from '../assets/logo.png'; // Importar el logo

const Navbar = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation('navbar'); // Usar traducciones del namespace "navbar"

  // Verifica si el usuario está autenticado
  const isAuthenticated = !!localStorage.getItem('token');

  // Función para cerrar sesión
  const handleLogout = () => {
    // Elimina el token y los datos del usuario
    localStorage.removeItem('token');
    localStorage.removeItem('user');

    // Redirige al usuario a la página de login
    navigate('/login');
  };

  // Función para cambiar el idioma
  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <motion.nav
      className="navbar navbar-expand-lg navbar-light bg-light"
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="container">
        {/* Logo con animación */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <motion.img
            src={logo}
            alt="Logo"
            style={{ width: '40px', height: '40px', marginRight: '10px' }}
            className="d-inline-block align-text-top"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
          />
          <motion.span
            style={{ fontSize: '1.5rem', fontWeight: 'bold' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            Nebstala
          </motion.span>
        </Link>

        {/* Botón colapsable para móviles */}
        <motion.button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
          whileHover={{ scale: 1.1 }}
        >
          <span className="navbar-toggler-icon"></span>
        </motion.button>

        {/* Menú de navegación */}
        <motion.div
          className="collapse navbar-collapse justify-content-end"
          id="navbarNav"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
        >
          <ul className="navbar-nav align-items-center">
            {/* Enlaces del menú */}
            <motion.li
              className="nav-item mx-3"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link className="nav-link" to="/">
                {t('home')}
              </Link>
            </motion.li>
            <motion.li
              className="nav-item mx-3"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link className="nav-link" to="/about">
                {t('about')}
              </Link>
            </motion.li>
            {/* Botón de login o logout */}
            <motion.li
              className="nav-item mx-3"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              {isAuthenticated ? (
                <button
                  className="btn btn-danger"
                  style={{
                    fontSize: '0.9rem',
                    padding: '5px 15px',
                    borderRadius: '5px',
                  }}
                  onClick={handleLogout}
                >
                  {t('logout')}
                </button>
              ) : (
                <Link
                  className="btn btn-primary"
                  style={{
                    fontSize: '0.9rem',
                    padding: '5px 15px',
                    borderRadius: '5px',
                    backgroundColor: '#008080',
                    borderColor: '#008080',
                  }}
                  to="/login"
                >
                  {t('login')}
                </Link>
              )}
            </motion.li>
            {/* Selector de idioma */}
            <motion.li
              className="nav-item mx-3"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="dropdown" style={{ marginLeft: '30px', marginRight: '-50px' }}>
                <button
                  className="btn btn-outline-secondary btn-sm dropdown-toggle"
                  type="button"
                  id="languageDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    fontSize: '0.8rem',
                    padding: '2px 10px',
                    borderRadius: '5px',
                  }}
                >
                  {i18n.language.toUpperCase()} {/* Muestra ES o EN */}
                </button>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange('en')}
                    >
                      EN
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleLanguageChange('es')}
                    >
                      ES
                    </button>
                  </li>
                </ul>
              </div>
            </motion.li>
          </ul>
        </motion.div>
      </div>
    </motion.nav>
  );
};

export default Navbar;